import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, TouchableOpacity, Platform, Image } from 'react-native';
import { Input, Button, Text, Icon, Colors, Line, Routes } from '../components';
import AuthController from '../controllers/authController';
import PetController  from '../controllers/petController';
import { StringUtils }    from '../utils';
import { MyAccountCards, SignInUniversal } from '../containers';
import { useNavigate } from 'react-router-dom';

class HomeMyAccountSection_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  componentDidMount() {

  }

  render() {
    let display_menu         = this.props.expand_menu;
    let display_sign_in      = this.props.expand_sign_in;
    let user_name            = StringUtils.displayName(this.props.user);
    let is_signed_in         = this.props.user && this.props.user.user_id && this.props.user.token ? true : false;
    let sign_in_btn_title    = display_sign_in ? 'Cancel' : 'Sign In';
    let is_web               = Platform.OS === 'web';
    let is_android           = Platform.OS === 'android';

    return <View style={{ }}>
      <View style={{ flexDirection: 'row' }}>
        { is_web ? <View style={{ height: 50 }}></View>
                 : <TouchableOpacity style={{ width: 100, height: 50, justifyContent: 'center', paddingLeft: 20 }}
                          onPress={ () => {
                            if (this.props.menu_action) {
                              this.props.menu_action();
                            }
                          }}>
                     <Icon name='bars' solid={true} size={25} color={ Colors.PRIMARY } />
                   </TouchableOpacity>
        }
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center'  }}>
          <Image style={{ height: 30, width: 200 }} resizeMode='contain' source={ require('../assets/images/dodovet-top-logo.png') } />
        </View>
        { is_web ? <View style={{ height: 50 }}></View>
                 : <TouchableOpacity style={{ width: 100, height: 50, alignItems: 'flex-end', justifyContent: 'center', paddingRight: 20 }}
                                    onPress={ () => {
                                      if (!is_signed_in && this.props.sign_in_action) {
                                        this.props.sign_in_action();
                                      }
                                      if (is_signed_in && this.props.profile_action) {
                                        this.props.profile_action();
                                      }
                                    }}>
                    { is_signed_in ? <Icon name='user' solid={true} size={25} color={ Colors.PRIMARY } />
                                   : <View style={{ backgroundColor: Colors.PRIMARY, padding: 8, paddingRight: 12, paddingLeft: 12, borderRadius: 20 }}>
                                       <Text style={{ fontSize: is_android ? 12 : 14, fontWeight: '500', color: 'white' }}>{ sign_in_btn_title }</Text>
                                     </View> }
                  </TouchableOpacity>
        }
      </View>

      { display_menu    ? this.render_menu_options()      : null }
      { display_menu    ? <View style={{ height: 20 }} /> : null }
      { display_sign_in ? this.render_sign_in()           : null }

      <Line style={{ width: 350, alignSelf: 'center' }} />

    </View>
  }

  render_sign_in = () => {
    return <View>
      <SignInUniversal
                success_action={ async () => {
                  let user    = await AuthController.getUser();
                  let user_id = user && user.user_id ? user.user_id : '';
                  let token   = user && user.token   ? user.token   : '';
                  if (this.props.sign_in_success) {
                    this.props.sign_in_success();
                  }
                  this.setState({ display_sign_in: !user_id || !token });
                }}/>
    </View>
  }

  render_menu_options = () => {
    return <View style={{ paddingLeft: 20, paddingRight: 20 }}>
      { this.render_menu_row('My Pets', () => { this.go_to_pets() }) }
      { this.render_menu_row('Past Consultations', this.go_to_past_consultations) }
      { this.render_menu_row('Manage Subscription', this.go_to_manage_subscription) }
      { this.render_menu_row('Settings', this.go_to_settings) }
      <View style={{ alignItems: 'center', paddingTop: 15 }}>
        <TouchableOpacity style={{ backgroundColor: Colors.PRIMARY, padding: 10, paddingRight: 20, paddingLeft: 20, borderRadius: 20 }}
                          onPress={ () => {
                            if (this.props.menu_action) {
                              this.props.menu_action();
                            }
                          }}>
          <Text style={{ fontSize: 16, fontWeight: '500', color: 'white' }}>Close Menu</Text>
        </TouchableOpacity>
      </View>
    </View>
  }

  render_menu_row = (label, press_action, skip_line) => {
    return <View>
      <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingTop: 15, paddingBottom: 15 }}
                        onPress={ () => {
                          if (press_action) {
                            press_action();
                          }
                        }}>
        <Text style={{ fontWeight: '500', fontSize: 18, color: Colors.DARK_GREY }}>{ label }</Text>
        <Icon name='arrow-circle-right' solid={true} size={18} color={ Colors.PRIMARY } />
      </TouchableOpacity>
      <Line hide={skip_line} />
    </View>
  }

  go_to_pets = () => {
    this.props.navigate(Routes.PET_LIST);
  }

  go_to_settings = () => {
    this.props.navigate(Routes.SETTINGS);
    if (this.props.menu_action) {
      this.props.menu_action();
    }
  }

  go_to_manage_subscription = () => {
    this.props.navigate(Routes.SETTINGS_MANAGE_SUBSCRIPTION);
  }

  go_to_past_consultations = () => {
    this.props.navigate(Routes.CONSULTATIONS_COMPLETED);
  }

}

function HomeMyAccountSection(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();
    return  <HomeMyAccountSection_Base {...props} navigate={navigate} />
  } else {
    //navigate={props.navigation.push}
    return  <HomeMyAccountSection_Base {...props} navigate={props.navigation.push} />
  }
}

const styles = StyleSheet.create({
  content_container: {

  },
});

export default HomeMyAccountSection
